import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, computed, input, signal } from "@angular/core";
import { IUnitsFilterGroups } from "src/app/infopage/new-new-dwelling/newdwelling.model";
import { RoomsGroupsComponent } from "./rooms-groups/rooms-groups.component";
import { FloorsGroupsComponent } from "./floors-groups/floors-groups.component";

type UnitsGroupMode = "rom" | "etg";

@Component({
    selector: "units-groups",
    imports: [CommonModule, RoomsGroupsComponent, FloorsGroupsComponent],
    templateUrl: "./units-groups.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: "./units-groups.component.scss",
})
export class UnitsGroupsComponent {
    unitsFilterGroups = input<IUnitsFilterGroups>(null);

    roomsGroups = computed(() => this.unitsFilterGroups()?.rooms ?? []);
    floorsGroups = computed(() => this.unitsFilterGroups()?.floors ?? []);

    mode = signal<UnitsGroupMode>("rom");

    setMode(mode: UnitsGroupMode): void {
        this.mode.set(mode);
    }
}
